import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '@material-ui/styles';
import { Typography } from '../Wrappers';
import useStyles from './styles';

export default function Footer() {
    const classes = useStyles();
    const theme = useTheme();
    const [showLinks, setShowLinks] = useState(true);

    useEffect(() => {
        window.addEventListener('resize', handleWindowWidthChange);
        handleWindowWidthChange();
        return function cleanup() {
            window.removeEventListener('resize', handleWindowWidthChange);
        };
    }, []);

    return (
        <div className={classes.footer}>
            <div className={classes.termsMenu}>
                <div className={showLinks ? classes.leftSide : classes.leftSideFull}>
                    <Typography
                        variant="subtitle2"
                        className={!showLinks ? classes.alignCenter : ''}
                    >
                        &copy; 2017-2021 SearchUnify. All rights reserved.
                    </Typography>
                </div>
                {showLinks ? (
                    <div className={classes.rightSide}>
                        <Link className={classes.rightSideLink} to="#">
                            <Typography variant="subtitle2">Sitemap</Typography>
                        </Link>
                        <Link className={classes.rightSideLink} to="#">
                            <Typography variant="subtitle2">Privacy Policy</Typography>
                        </Link>
                        <Link className={classes.rightSideLink} to="#">
                            <Typography variant="subtitle2">Terms & Conditions</Typography>
                        </Link>
                    </div>
                ) : (
                    ''
                )}
            </div>
        </div>
    );

    function handleWindowWidthChange() {
        const windowWidth = window.innerWidth;
        const breakpointWidth = 850;
        const isSmallScreen = windowWidth < breakpointWidth;

        if (isSmallScreen && showLinks) {
            setShowLinks(false);
        } else if (!isSmallScreen && !showLinks) {
            setShowLinks(true);
        }
    }
}
